import React from "react"

import getMessageBaseClasses from "../../utils/MessageUtils"
import { IHTMLMessage } from "../.."

export type Props = IHTMLMessage

export default function HTMLMessage({
    content,
    isSentByUser,
    ...args
}: Props): JSX.Element {
    const classes = getMessageBaseClasses({
        shouldAddNoteTheme: !isSentByUser,
        shouldAddCloudBackground: isSentByUser,
    })

    return (
        <div
            className={classes}
            dangerouslySetInnerHTML={{
                __html: content,
            }}
            {...args}
        ></div>
    )
}
